window.setParametroConfigTaquilla = function (parametro, valor, noAlmacenarEnTaquilla) {

	localStorage.setItem(parametro, valor);

	if (parametro == window.PARAMETRO_CONFIGURACION_ID_EMPRESA_TAQUILLA || parametro == window.PARAMETRO_CONFIGURACION_ID_CANAL_TAQUILLA) {
		$.cookie(parametro, valor, { expires: 3000, path: '/' });
	}

	if (boxmethods != null && !noAlmacenarEnTaquilla) {
		//TODO: revisar funcionamiento de esto
		//		alert('parametro = ' + parametro + ', valor = ' + valor);

		boxmethods.setParamConfig(parametro, valor);
	}
}

window.getParametroConfigTaquilla = function(parametro)
{
	let valor = localStorage.getItem(parametro);

	if(valor == null && (parametro == window.PARAMETRO_CONFIGURACION_ID_EMPRESA_TAQUILLA || parametro == window.PARAMETRO_CONFIGURACION_ID_CANAL_TAQUILLA))
	{
		valor = $.cookie(parametro);
	}

	return valor;
}

	//================== FOUNDATION DATETIMEPICKER =====================

	window.initDateTimePicker = () => (function ($) {
		if (typeof ($.fn.fdatetimepicker) != "undefined") {
			$.fn.fdatetimepicker.dates[localLanguage] = {
				days: getWeekdaysLongLiteralArray(),
				daysShort: getWeekdaysShortLiteralArray(),
				daysMin: getWeekdaysAcronymsArray(),
				months: getMonthsLongLiteralArray(),
				monthsShort: getMonthsShortLiteralArray(),
				today: "Today"
			};
		}
	}(jQuery));

	initDateTimePicker();


//============================== JS UTILS ==================================
window.isDefined = function (variable) {
	return (typeof variable !== "undefined");
}


//============================== MATH UTILS ==================================
/**
 * Round an amount to cents.
 */
window.roundAmount = function (amount) {
	return (Math.round(amount * 100) / 100);
}

window.getLiteralEmpresaFormaPago = function (idEmpresaFormaPago, idFormaPago) {
	let formaPago;
	for (let i in window.formasPago) {
		formaPago = window.formasPago[i];

		if (idEmpresaFormaPago == formaPago.idEmpresaFormaPago) {
			return formaPago.formaPago;
		}
	}
	return getPaymentMethodLiteral(idFormaPago);
}

window.getLiteralIdioma = function (idioma) {
	switch (idioma) {
		case "ar_EG": return "عربي";
		case "ca_ES": return "català";
		case "da_DK": return "dansk";
		case "de_DE": return "deutsch";
		case "en_GB": return "english";
		case "en_HK": return "english";
		case "en_US": return "english";
		case "es_AR": return "español";
		case "es_CL": return "español";
		case "es_CO": return "español";
		case "es_EC": return "español";
		case "es_ES": return "español";
		case "es_GT": return "español";
		case "es_MX": return "español";
		case "es_PE": return "español";
		case "es_PR": return "español";
		case "es_UY": return "español";
		case "eu_ES": return "euskara";
		case "fr_FR": return "français";
		case "gl_ES": return "galego";
		case "in_ID": return "bahasa indonesia";
		case "it_IT": return "Italiano";
		case "ja_JP": return "日本の";
		case "ko_KR": return "한국어";
		case "nl_NL": return "nederlands";
		case "pl_PL": return "Polski";
		case "pt_BR": return "português";
		case "pt_PT": return "português";
		case "zh_CN": return "简体中文";
		case "zh_HK": return "繁体中文";
	}
	return "";
}

// ------------------ UTILIDADES -----------------
window.getLitEventoSesion = function (litEvento = "", utilizaLitSesion = false, litSesion = "", fechaCelebracionStr = new Date()) {
	let litEventoSesion = window.getTextoLongitudMaxima(litEvento, 20) + " - ";

	if (utilizaLitSesion)
	{
		litEventoSesion += window.getTextoLongitudMaxima(litSesion, 30);
	}
	else
	{
		litEventoSesion += formatDateTime(fechaCelebracionStr);
	}

	return litEventoSesion;
}


window.getLitSesion = (utilizaLitSesion = false, litSesion = "", fechaCelebracionStr = new Date()) => 
{
	let lit = window.getTextoLongitudMaxima(litSesion, 20);

	if (!utilizaLitSesion)
	{
		lit = formatDateTime(fechaCelebracionStr);
		
	}
	return lit;
}

window.getSesionFromLista = function (idSesion, listaSesiones) {
	if (listaSesiones != null && listaSesiones.length > 0 && idSesion != null) {
		for (let i in listaSesiones) {
			if (listaSesiones[i].idSesion == idSesion)
				return listaSesiones[i];
		}
	}

	return null;
}

window.getEmpresaFromLista = function (idEmpresa, listaEmpresas) {
	if (listaEmpresas != null && listaEmpresas.length > 0 && idEmpresa != null) {
		for (let i in listaEmpresas) {
			if (listaEmpresas[i].idEmpresa == idEmpresa)
				return listaEmpresas[i];
		}
	}

	return null;
}

window.getUrlRedirectionFromList = function (idCmsRedirection, urlRedirectionsList)
{
	if (urlRedirectionsList != null && urlRedirectionsList.length > 0 && idCmsRedirection != null)
	{
		for (let i in urlRedirectionsList)
		{
			if (urlRedirectionsList[i].idCmsRedirections == idCmsRedirection)
				return urlRedirectionsList[i];
		}
	}

	return null;
}

window.getSaleChannelsFromList = function (idChannel, saleChannelsList) {
	if (saleChannelsList != null && saleChannelsList.length > 0 && idChannel != null) {
		for (let i in saleChannelsList) {
			if (saleChannelsList[i].idCanal == idChannel)
				return saleChannelsList[i];
		}
	}

	return null;
}

window.getRecintoFromLista = function (idRecinto, listaRecintos) {
	if (listaRecintos != null && listaRecintos.length > 0 && idRecinto != null) {
		for (let i in listaRecintos) {
			if (listaRecintos[i].idRecinto == idRecinto)
				return listaRecintos[i];
		}
	}

	return null;
}

window.getEventoFromLista = function (idEvento, listaEventos) {
	if (listaEventos != null && listaEventos.length > 0 && idEvento != null) {
		for (let i in listaEventos) {
			if (listaEventos[i].idEvento == idEvento)
				return listaEventos[i];
		}
	}

	return null;
}

window.getSalaFromLista = function (idSala, listaSalas) {
	if (listaSalas != null && listaSalas.length > 0 && idSala != null) {
		for (let i in listaSalas) {
			if (listaSalas[i].idSala == idSala)
				return listaSalas[i];
		}
	}

	return null;
}

window.getChannelIdOfSalesChannelOrganization = function (idOrganization) {
	if (typeof Canales != 'undefined' && Canales != null && Canales.length > 0) {
		for (let channel of Canales) {
			if (channel.idEmpresa == idOrganization) {
				return channel.idCanal;
			}
		}
	}

	return null;
}

window.getCanal = function (idCanal) {
	if (Canales != null && Canales.length > 0 && idCanal != null) {
		for (let i in Canales) {
			if (Canales[i].idCanal == idCanal)
				return Canales[i];
		}
	}

	return null;
}

window.getZonaFromLista = function (idZona, listaZonas) {
	if (listaZonas != null && listaZonas.length > 0 && idZona != null) {
		for (let i in listaZonas) {
			if (listaZonas[i].idZona == idZona)
				return listaZonas[i];
		}
	}

	return null;
}

window.isMsIE = function () {
	const ua = window.navigator.userAgent;
	const msie = ua.indexOf("MSIE ");
	return (msie >= 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./));
}


/**
 * Devuelve el texto recortado a la longitud máxima. Si supera esa longitud, opcionalmente puede aÃ±adir un sufijo (...)
 * @param texto Texto
 * @param longitud Longitud máxima
 * @param sufijo Sufijo (opcional)
 * @returns Texto recortado
 */
window.getTextoLongitudMaxima = function (texto, longitud, sufijo) {
	if (texto == null || texto.length < longitud) {
		return texto;
	}

	let t2 = texto.substring(0, longitud);
	if (sufijo != null && sufijo.length > 0) {
		t2 = t2 + sufijo;
	}

	return t2;
}

if (typeof String.prototype.startsWith !== 'function') {
	String.prototype.startsWith = function (prefix) {
		return this.indexOf(prefix) == 0;
	};
}


if (typeof String.prototype.endsWith !== 'function') {
	String.prototype.endsWith = function (suffix) {
		return this.indexOf(suffix, this.length - suffix.length) !== -1;
	};
}

/**
 * Añade a la lista un nuevo IdValor, si no estÃ¡ ya en la lista
 * @param nuevoElemento
 * @param lista
 */
window.addDistinctIdValor = function (nuevoElemento, lista) {
	for (let j in lista) {
		if (lista[j].id == nuevoElemento.id)
			return;
	}

	lista.push(nuevoElemento);
}

/**
 * Genera el html de los option de una lista de objetos IdValor
 * @param lista
 * @returns {String}
 */
window.generaOptionsListaIdValor = function (lista) {
	let html = "";
	if (lista != null && lista.length > 0) {
		for (let i in lista) {
			html += "<option value='" + lista[i].id + "' >" + lista[i].valor + "</option>";
		}
	}
	return html;
}

/**
 * Obtiene el objeto de una lista por su ID
 */
window.getObjetoPorId = function (id, lista, campoId) {
	if (campoId == null)
		campoId = 'id';

	for (let i in lista) {
		if (id == lista[i][campoId])
			return lista[i];
	}
	return null;
}


/**
 * Añade el objeto a la lista. Si ya existe un objeto con ese ID, lo sustituye.
 */
window.setObjetoPorId = function (objeto, lista, campoId) {
	if (campoId == null)
		campoId = 'id';

	const campoIdObjeto = objeto[campoId];

	let encontrado = false;
	let posicion = 0;
	if (lista == null) {
		lista = new Array();
		lista[0] = objeto;
	}
	else 
	{
		let i;
		for (i = 0; i < lista.length && !encontrado; i++) {
			if (campoIdObjeto == lista[i][campoId]) {
				lista[i] = objeto;
				encontrado = true;
				posicion = i;
			}
		}
		if (!encontrado) {
			lista[i] = objeto;
			posicion = i;
		}
	}

	return posicion;
}

/**
 *  Obtains the object from an array by two Ids
 */
window.getObjectByTwoIds = function (firstId, secondId, array, firstColumn, secondColumn) {
	for (let i in array) {
		let firstIdValue = array[i][firstColumn];
		let secondIdValue = array[i][secondColumn];

		if (firstId == firstIdValue && secondId == secondIdValue) {
			return array[i];
		}
	}
	return null;
}

/**
 * Elimina el objeto de la lista por su ID
 */
window.deleteObjetoPorId = function (id, lista, campoId) {
	if (campoId == null)
		campoId = 'id';

	for (let i = 0; i < lista.length; i++) {
		if (id == lista[i][campoId]) {
			lista.splice(i, 1);
			return i;
		}
	}

	return -1;
}

/**
 * Deletes an object from the list given two ids
 */
window.deleteObjectByTwoIds = function (firstId, secondId, array, firstColumn, secondColumn) {
	for (let i = 0; i < array.length; i++) {
		const firstIdValue = array[i][firstColumn];
		const secondIdValue = array[i][secondColumn];

		if (firstId == firstIdValue && secondId == secondIdValue) {
			array.splice(i, 1);
			return i;
		}
	}

	return -1;
}

/**
 * Clona el array origen
 */
window.clonaArray = function (arrayOrigen) {
	let array = new Array();
	for (let i in arrayOrigen) {
		array.push(arrayOrigen[i]);
	}
	return array;
}

/**
 * Deep clone of a given object
 * @param obj
 * @returns
 */
window.deepCloneObject = function (obj) {
	return JSON.parse(JSON.stringify(obj));
}

/**
 * Crea un objeto IdValor
 * @param id
 * @param valor
 * @param valor2
 * @returns IdValor
 */
window.creaIdValor = function (id, valor, valor2) {
	const idVal = new IdValor();
	idVal.id = id;
	idVal.valor = valor;
	idVal.valor2 = valor2;

	return idVal;
}


/**
 * Para utilizar en la ordenación de objetos IdValor
 * @param b1
 * @param b2
 * @returns
 */
window.ordenaValor = function (b1, b2) {
	return b1.valor.localeCompare(b2.valor);
}

window.getParamsFromUrl = function (url) {
	let paramsObj = new Object();

	let queryString;

	if (url != null && (url.indexOf("?") != -1)) {
		queryString = url.split("?")[1].split("&");
	}
	else {
		queryString = window.location.search.substr(1).split("&");
	}

	let currentQuery;

	for (let i = 0; i < queryString.length; i++) {
		currentQuery = queryString[i].split("=");
		paramsObj[currentQuery[0]] = unescape(currentQuery[1]);
	}

	return paramsObj;
}

window.fixUTFString = function (utftext) {
	let string = "";
	let i = 0;
	let c2;
	let c3;
	let c = c2 = 0;

	while (i < utftext.length) {
		c = utftext.charCodeAt(i);
		if (c < 128) {
			string += String.fromCharCode(c);
			i++;
		}
		else if ((c > 191) && (c < 224)) {
			c2 = utftext.charCodeAt(i + 1);
			string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
			i += 2;
		}
		else {
			c2 = utftext.charCodeAt(i + 1);
			c3 = utftext.charCodeAt(i + 2);
			string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
			i += 3;
		}
	}
	return string;
}


/**
 * Load a notification item on the lower right side of the app.
 * @param {array} toastInfo - Both parameters will display messages on the notification. First one is mandatory.
 * @param {string} type - Type of notification to display: "success", "error", "warning" or "ajax".
 * @param {number} sec - Time to show the notification object(optional). If the value is 0, the notification won't disappear.
 */
window.loadNotification = function (toastInfo, type, sec) {
	const title = toastInfo.length > 0 && toastInfo[0] != null ? window.truncateInfo(toastInfo[0]) : null;
	const content = toastInfo.length > 0 && toastInfo[1] != null ? window.truncateInfo(toastInfo[1]) : null;
	const toastList = document.getElementsByClassName('toast');

	toastr.options.positionClass = "toast-bottom-right";
	toastr.options.timeOut = "3600000";
	toastr.options.tapToDismiss = false;

	// Add our icon to Toastr
	const iconContainer = document.createElement('div');
	iconContainer.className = 'obj-notif-icon';

	const iconSpace = document.createElement('div');
	iconSpace.className = 'icon-notif';

	const iconEl = document.createElement('i');

	if (type == "success") {
		iconSpace.style.backgroundColor = "#a5dc86";
		iconEl.className = "icon-notif-font palco4icon palco4icon-check-big";
		toastr.success(content, title);
	}
	else if (type == "error" || type == "notification-error") {
		iconSpace.style.backgroundColor = "#f27474";
		iconEl.className = "icon-notif-font palco4icon palco4icon-close";
		toastr.error(content, title);
	}
	else if (type == "warning") {
		iconSpace.style.backgroundColor = "#FF9915";
		iconEl.className = "icon-notif-font palco4icon palco4icon-alert-circle-o";
		toastr.warning(content, title);
	}
	else if (type == "ajax") {
		iconSpace.style.backgroundColor = "#00e1e1";
		iconEl.className = "icon-notif-font palco4icon palco4icon-refresh-alt";
		toastr.info(content, title);
	}
	else if (type == "notification") {
		iconSpace.style.backgroundColor = "#b19fcc";
		iconEl.className = "icon-notif-font palco4icon palco4icon-email-notification";
		toastr.success(content, title);
	}
	else if (type == "waiting") {
		iconSpace.style.backgroundColor = "#51bcd7";
		iconEl.className = "icon-notif-font palco4icon palco4icon-history-time";
		toastr.success(content, title);
	}

	window.giveContentNotification(content);

	if (sec == null && type == "warning") {
		sec = 4000;
	} else if (sec == null & (type == "error" || type == "notification" || type == "waiting")) {
		sec = 6000;
	} else if (sec == null) {
		sec = 2000;
	}

	const toastId = toastList.length;
	if (sec != 0) {
		setTimeout(function () {
			window.closeNotification($('#toast-' + toastId)[0]);
		}, sec);
	} else {
		const anchorContainer = document.createElement('div');
		const anchorClose = document.createElement('a');
		anchorClose.innerHTML = polyglot.t("Close");
		anchorContainer.classList.add('obj-notif-a-container')
		anchorClose.classList.add('obj-notif-close');
		anchorClose.onClick = "window.closeNotification($('#toast-${toastId}')[0])";
		anchorContainer.appendChild(anchorClose);
		toastList[0].appendChild(anchorContainer);
	}

	iconSpace.appendChild(iconEl);
	iconContainer.appendChild(iconSpace);

	// Apply equivalent Notification CSS classes
	toastList[0].classList.add("animated");
	toastList[0].classList.add("bounceInUp");
	toastList[0].id = 'toast-' + toastList.length;
	toastList[0].style.backgroundSize = "0";
	toastList[0].insertBefore(iconContainer, toastList[0].childNodes[0]);

	if (sec == 0 && toastId != null) {
		$('#toast-' + toastId + ' a').on("click", function (ev) {
			window.closeNotification(ev.target.parentNode.parentNode);
		});
	}
	else if (type == "waiting" || type == "notification" || type == "notification-error") {
		$('#toast-' + toastId).on("click", function (ev) {
			window.closeNotification($('#toast-' + toastId)[0]);
			
			if(!notificationManager.isBoxofficeMode)
			{
				$("#btn-notifications").click();
				document.getElementById('wrapper-panels').parentElement.parentElement.scrollTo({ top: 0, behavior: 'smooth' });
			}
		});
	}

	window.lastNotifType = type;
}

window.truncateInfo = function (info) {
	const MAX_INFO_LENGTH = 74;
	return info.length > MAX_INFO_LENGTH
		? info.slice(0, MAX_INFO_LENGTH) + "..."
		: info;
}

window.giveContentNotification = function (content) {
	$('.toast-title')[0].classList.add('toast-el');

	if (content == null) {
		$('.toast-el').slice(0, 1).wrapAll('<div class="toast-el-container" />');
		return;
	}

	$('.toast-title')[0].classList.add('with-toast-msg-tit');
	$('.toast-message')[0].classList.add('with-toast-msg-msg');
	$('.toast-message')[0].classList.add('toast-el');
	$('.toast-el').slice(0, 2).wrapAll('<div class="toast-el-container" />');
}

/*
 * Removes a notification created using window.loadNotification()
 * @param {DOMNode} child - DOM Node element that corresponds to the notification.
 */
window.closeNotification = function (child) {
	if (typeof (child) != "undefined" && child != null) {
		document.getElementById('toast-container').removeChild(child);
	}
}

window.excludeSymbols = function (event) {
	const letterNumber = /^[0-9a-zA-Z]+$/;
	return letterNumber.test(event.key);
}

window.allowOnlyDecimalNumbers = function(event) {
	const key = event.key;
	const value = event.target.value;

	if (
		key === "Backspace" ||
		key === "Tab" ||
		key === "ArrowLeft" ||
		key === "ArrowRight" ||
		key === "Delete"
	) {
		return true;
	}
	if (key === '.' && !value.includes('.')) {
		return true;
	}

	if (/^[0-9]$/.test(key)) {
		const selectionStart = event.target.selectionStart;
		const selectionEnd = event.target.selectionEnd;

		const newValue =
			value.slice(0, selectionStart) + key + value.slice(selectionEnd);

		const parts = newValue.split('.');

		if (parts.length === 1) {
			return true;
		} else if (parts.length === 2) {
			return parts[1].length <= 2;
		} else {
			return false;
		}
	}

	return false;
}
// ============================ AJAX ===========================


window.lastAjaxException = null;
window.errorCodesToAvoid = [
	"ERR_LOADING_BACKOFFICE_NOTIFICATIONS"
];

/**
 * Tratamiento genérico de los errores AJAX.
 */
window.tratamientoErrores = function (msg, exception) {

	// Avoid error when can´t load backoffice notifications
	if(exception != null && exception.errorCode != null && exception.errorCode.code != null && errorCodesToAvoid.includes(exception.errorCode.code))
	{
		return;
	}
	
	date =new Date;
	formatDateTime(date)
	window.lastAjaxException = exception;
	let msgError = "";
	let msgFooter = "";
	console.log("************error*****************");
	console.log('Date & Time:', date);
	if (exception != null) {
		console.log("from : "+exception.javaClassName);
		if(exception.errorCode!=null) {
			console.log("exception code: " + exception.errorCode.code);
		}
		console.error("*********errors stack***********");
		if (exception.showMessage) {
			msgFooter = exception.message;
		}

		if ((exception.javaClassName == "es.ticketing.exceptions.TicketingException" || exception.javaClassName == "es.ticketing.exceptions.VentaException" || exception.javaClassName == "es.ticketing.exceptions.PagoException"))
			msgError = polyglot.t("ERROR_CODE." + exception.errorCode.code);
		else if (exception.javaClassName == "es.ticketing.util.jdbc.DbException")
			msgError = polyglot.t("A_database_error_ocurred");
		else if (exception.javaClassName == "es.ticketing.util.SeguridadException")
			msgError = polyglot.t("You_dont_have_enough_permissions_to_execute_the_selected_action");
		else
			msgError = exception.message;
	}
	else {
		msgError = msg;
	}

	if (typeof callbackErrorLoadingScreeen === "function") {
		callbackErrorLoadingScreeen();
	}

	window.cambiarVentanaEsperaKO(false, msgError, msgFooter);
}

dwr.engine.setErrorHandler(window.tratamientoErrores);


window.existeInArray = function (cadena, arr) {
	for (let iContCad in arr) {
		if (cadena == arr[iContCad]) {
			return true;
		}
	}
	return false;
}

$.fn.clearForm = function () {
	return this.each(function () {
		const type = this.type, tag = this.tagName.toLowerCase();
		if (tag == 'form')
			return $(':input', this).clearForm();
		if (type == 'text' || type == 'password' || tag == 'textarea')
			this.value = '';
		else if (type == 'checkbox' || type == 'radio')
			this.checked = false;
		else if (tag == 'select')
			this.selectedIndex = 0;
	});
};



window.removeSpecialCharacters = function (str, haveSpace) {
	// Delete extra spaces
    str = str.trim().replace(/\s+/g, ' ');
    
	let res = '';
	let c;
	for (let i = 0; i < str.length; i++) {
		c = str.charAt(i);
		res += window.mapTextoBuscar[c] || c;
	}
		
	//special characters
	res = res.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
	
	// Si es false o no se proporciona se eliminan los espacios
	if (!haveSpace)
	{
		//white spaces
		res = res.replace(/\s/g, '');
	}
	
	return res;
}

/**
 * Carga los datos de una tabla DateTables
 * @param tabla Tabla inicializada
 * @param listaDatos Array con objetos
 * @param funcionFilaDatos Funcion que genera una array con los datos de la tabla a partir de un objeto
 */
window.cargarDataTables = function (tabla, listaDatos, funcionFilaDatos) {
	tabla.fnClearTable();

	let arrayDatosTabla;

	if (listaDatos != null && listaDatos.length > 0) {
		arrayDatosTabla = new Array();

		for (let i in listaDatos) {
			let dt = listaDatos[i];
			if (dt != null) {
				arrayDatosTabla.push(funcionFilaDatos(dt));
			}
		}

		if (arrayDatosTabla.length > 0) {
			tabla.fnAddData(arrayDatosTabla);
		}
	}
}


window.getUrlIconoIdioma = function (idioma) {
	return "img/lang/" + idioma + ".png";
}


//============================== VENTANA ESPERA ==================================
/**
* Estilo de las ventanas de espera
*/
$.blockUI.defaults.css = {
	padding: 0,
	margin: 0,
	color: '#2779AA',
	border: '1px solid #D7EBF9',
	backgroundColor: '#FFFFFF',
	cursor: 'wait'
};

window.ventanaEsperaAjaxOn = false;
window.idVentanaSupEspera = null;
window.inicioEsperaVentana = null;
window.blockTimeoutId = null;

/**
 * Muestra la ventana de espera mientras se realiza una llamada AJAX, para bloquear al usuario.
 */
window.crearVentanaEspera = function (idVentanaSuperior) {
	if (ventanaEsperaAjaxOn)
		return;

	idVentanaSupEspera = idVentanaSuperior;
	
	if (blockTimeoutId != null && boxmethods != null) 
	{
	   clearTimeout(blockTimeoutId);
	   blockTimeoutId = null;
	}

	$.blockUI(
		{
			message: $('#divEspera').html(),
			showOverlay: true,
			overlayCSS: {
				backgroundColor: '#fff',
				opacity: '0.5'
			},
			css: {
				top: ($(window).height() - 128) / 2 + 'px',
				left: ($(window).width() - 128) / 2 + 'px',
				width: '128px',
				border: 'none',
				backgroundColor: 'none'
			},
			baseZ: 2000
		});

	inicioEsperaVentana = new Date();
	ventanaEsperaAjaxOn = true;
	
	if (boxmethods != null)
	{
		blockTimeoutId = setTimeout(function(){
	    if (ventanaEsperaAjaxOn) {
		      $.unblockUI();
		      ventanaEsperaAjaxOn = false;
		    }
		    blockTimeoutId = null;
		  }, 60000);
	}
}

/**
 * Cambia la venta de espera a OK.
 */
window.cambiarVentanaEsperaOK = function (cerrarVentanaSup) {
	if (ventanaEsperaAjaxOn) {
		
		if (blockTimeoutId != null && boxmethods != null) 
		{
		   clearTimeout(blockTimeoutId);
		   blockTimeoutId = null;
		}
		
		let tiempoEspera = 0;
		if (inicioEsperaVentana != null) {
			tiempoEspera = (new Date()).getTime() - inicioEsperaVentana.getTime();
		}

		$.unblockUI();
		ventanaEsperaAjaxOn = false;

		// Si tarda muy poco (menos de 1 seg) no se muestra el OK
		if (tiempoEspera > 1000) {
			//TODO: mostrar notificacion solo si ha habido un push en bbdd
			//window.loadNotification([polyglot.t("Saved_successfully")], "success", 1000);

			setTimeout("window.cerrarVentanaEspera(" + cerrarVentanaSup + ")", 250);
		}
		else {
			window.cerrarVentanaEspera(cerrarVentanaSup);
		}
	}
}


/**
 * Cambia la venta de espera a KO.
 */
window.cambiarVentanaEsperaKO = function (cerrarVentanaSup, msgError, msgFooter) {
	$.unblockUI();
	ventanaEsperaAjaxOn = false;
	const ERROR_TYPE = "error";
	const ERROR_TITLE = polyglot.t("Error");

	if (msgFooter != null && msgError != null) {
		const errorMessage = msgError + "<div style='margin-top: 1rem; border-top: 1px solid #cccccc; padding-top: 1rem; font-style: italic;' >" + msgFooter + "</div>";
		setTimeout(function () { swal({ title: ERROR_TITLE, type: ERROR_TYPE, html: errorMessage }) }, 2000);
	}
	else if (msgError != null) {
		setTimeout(function () { swal({ title: ERROR_TITLE, html: msgError, type: ERROR_TYPE }) }, 2000);
	}
	else {
		setTimeout(function () { swal({ title: ERROR_TITLE, type: ERROR_TYPE }) }, 2000);
	}

}

function swalCancelFunction(dismiss, cancelFn)
{
	return () =>  { if (dismiss === 'cancel' && cancelFn != null) setTimeout(cancelFn, 10) };
}

window.confirmarMensaje = function(titulo, mensaje, textoOK, textoCancelar, funcionOk, funcionCancelar, htmlMessage) {
	swal({
		title: titulo,
		html: mensaje,
		html: htmlMessage != null && htmlMessage.length > 0 ? htmlMessage : '',
		type: "question",
		showCancelButton: true,
		confirmButtonText: textoOK,
		cancelButtonText: textoCancelar,
		confirmButtonClass: 'btn-alert right',
		cancelButtonClass: 'btn-alert-secondary'
	}).then(function () {
		if (funcionOk != null) {
			setTimeout(funcionOk, 10);
		}
	}, dismiss => swalCancelFunction(dismiss, funcionCancelar)).catch(swal.noop);
}

window.aceptarMensajeAviso = function (titulo, mensaje, segundoMensaje, textoOK, textoConfirmar, textoCancelar, funcionOk, funcionCancelar) {
	swal({
		title: titulo,
		html: mensaje,
		type: "warning",
		showCancelButton: true,
		confirmButtonText: textoOK,
		cancelButtonText: textoCancelar,
		confirmButtonClass: 'btn-alert right',
		cancelButtonClass: 'btn-alert-secondary'
	}).then(function () {
		if (funcionOk != null) {
			setTimeout(function () { confirmarMensaje(titulo, segundoMensaje, textoConfirmar, textoCancelar, funcionOk, funcionCancelar) }, 10);
		}
	}, dismiss => swalCancelFunction(dismiss, funcionCancelar)).catch(swal.noop);
}


//==================================== Funciones para alert y confirm =========================================

window.alertPalco = function (pTitle, pText, pType, pTimer, callbackFunction) {
	const params = { confirmButtonClass: "btn-alert" };
	if (pTitle != null) params.title = pTitle;
	if (pText != null) params.html = pText;
	if (pType != null) params.type = pType;
	if (pTimer != null) params.timer = pTimer;
	if (callbackFunction != null) {
		swal(params).then(function () {
			if (callbackFunction != null)
				setTimeout(callbackFunction, 10);
		}).catch(swal.noop);
	}
	else {
		swal(params).catch(swal.noop);
	}
}

window.alerta = function (mensaje) {
	window.alertPalco(null, mensaje);
}

window.alertaOK = function (titulo, mensaje) {
	window.alertPalco(titulo, mensaje, "success");
}

window.alertaOKtimer = function (titulo, mensaje) {
	window.alertPalco(titulo, mensaje, "success", 1000);
}

window.alertaOKcallback = function (titulo, mensaje, funcion) {
	window.alertPalco(titulo, mensaje, "success", null, funcion);
}

window.alertaExcepcion = function (titulo, mensaje) {
	if (mensaje) {
		window.alertPalco(titulo, mensaje, "warning");
	}
	else {
		window.alertPalco(polyglot.t("Error"), titulo, "warning");
	}

}

window.alertaExcepcionCallback = function (titulo, mensaje, callbackFunction) {
	if (mensaje) {
		window.alertPalco(titulo, mensaje, "warning", null, callbackFunction);
	}
	else {
		window.alertPalco(polyglot.t("Error"), titulo, "warning", null, callbackFunction);
	}

}

window.alertaKO = function (titulo, mensaje) {
	if (mensaje) {
		window.alertPalco(titulo, mensaje, "error");
	}
	else {
		window.alertPalco(polyglot.t("Error"), titulo, "error");
	}
}


// =========== COLORES ===========

window.lettersHex = '0123456789ABCDEF'.split('');

window.getRandomColor = function () {
	let color = '#';
	for (let i = 0; i < 6; i++) {
		color += window.lettersHex[Math.round(Math.random() * 15)];
	}
	return color;
}


/**
 * Función para modificar luminosidad de un color, o mezclar con otro color
 * @param p Porcentaje (-1.0 a 1.0) para
 * @param c0 Color inicial
 * @param c1 Color mezcla (opcional). Si se indica el resultado será la mezcla del color inicial con este. Sino la mezcla con blanco (+) o negro (-)
 * @returns Color resultado
 */
window.shadeBlend = function (p, c0, c1) {
	if (p == null || c0 == null) {
		return "#000000";
	}

	const n = p < 0 ? p * -1 : p, u = Math.round, w = parseInt;
	if (c0 != null && c0.length > 7) {
		let f = c0.split(","), t = (c1 ? c1 : p < 0 ? "rgb(0,0,0)" : "rgb(255,255,255)").split(","), R = w(f[0].slice(4)), G = w(f[1]), B = w(f[2]);
		return "rgb(" + (u((w(t[0].slice(4)) - R) * n) + R) + "," + (u((w(t[1]) - G) * n) + G) + "," + (u((w(t[2]) - B) * n) + B) + ")"
	}
	else {
		let f = w(c0.slice(1), 16), t = w((c1 ? c1 : p < 0 ? "#000000" : "#FFFFFF").slice(1), 16), R1 = f >> 16, G1 = f >> 8 & 0x00FF, B1 = f & 0x0000FF;
		return "#" + (0x1000000 + (u(((t >> 16) - R1) * n) + R1) * 0x10000 + (u(((t >> 8 & 0x00FF) - G1) * n) + G1) * 0x100 + (u(((t & 0x0000FF) - B1) * n) + B1)).toString(16).slice(1)
	}
}


window.rgb2hex = function (rgb) {
	rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
	return (rgb && rgb.length == 4) ? "#" +
		("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
		("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
		("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
}


window.getContrastYIQ = function (hexcolor) {
	if (hexcolor.substr(0, 1) == "#")
		hexcolor = hexcolor.substr(1);

	if (hexcolor.length == 3)
		hexcolor = hexcolor.substr(0, 1) + hexcolor.substr(0, 1) + hexcolor.substr(1, 2) + hexcolor.substr(1, 2) + hexcolor.substr(2, 3) + hexcolor.substr(2, 3);

	const r = parseInt(hexcolor.substr(0, 2), 16);
	const g = parseInt(hexcolor.substr(2, 2), 16);
	const b = parseInt(hexcolor.substr(4, 2), 16);
	const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
	return (yiq >= 128) ? 'black' : 'white';
}


window.hex2rgb = function (hex) {
	// long version
	let r = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
	if (r) {
		return r.slice(1, 4).map(function (x) { return parseInt(x, 16); });
	}
	// short version
	r = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
	if (r) {
		return r.slice(1, 4).map(function (x) { return 0x11 * parseInt(x, 16); });
	}
	return null;
}


window.getRandomColorHex = function () {
	return '#' + lpad(Math.floor(Math.random() * 16777215).toString(16), 6, '0');
}

//=========== FIN COLORES ===========

window.onPasswordEyeClicked = function (idElement, showPasswd) {
	let type = "password";
	let eye = "eye";
	if (showPasswd) {
		type = "text";
		eye = "eye-off";
	}
	$(idElement + " input").attr("type", type);
	$(idElement + " i").replaceWith('<i class="palco4icon palco4icon-' + eye + '"></i>');
}

window.generateCountriesSuggestionJsonArray = function (valueAsCode) {
	let countriesList = [];
	let jsonSuggestionOption;

	if (valueAsCode && regions != null && regions.length > 0) {
		let region;
		for (let i = 0; i < regions.length; i++) {
			region = regions[i];
			jsonSuggestionOption = {
				value: region.iso,
				text: region.country
			};
			countriesList.push(jsonSuggestionOption);
		}
	} else if (countries != null && countries.length > 0) {
		for (let i = 0; i < countries.length; i++) {
			let country = countries[i];
			jsonSuggestionOption = {
				value: country,
				text: country
			};
			countriesList.push(jsonSuggestionOption);
		}
	}
	return countriesList;
}

window.loadCountrySelect = function (selector, valueAsCode) {
	const jsonSuggestionsArray = window.generateCountriesSuggestionJsonArray(valueAsCode);
	const jqueryComponentId = (selector == undefined) ? "#countryAccredited" : selector;
	$(jqueryComponentId).empty();
	$.each(jsonSuggestionsArray, function (i, option) {
		$(jqueryComponentId).append($("<option>", option));
	});
}



window.mostrarContenedor = function (elemento) {

	$("body").css("overflow", "hidden");
	$("#cont-pantalla-ppal").hide();
	$(elemento + " cont-btns-flot-bottom").hide();
	$(elemento).show();
	$(elemento).addClass("fadeInUp animated").one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
		function () {
			$(elemento).removeClass("fadeInUp animated");
			$(elemento + " cont-btns-flot-bottom").show();
			scroll(0, 0);
			$("body").css("overflow", "auto");
		});

}

window.ocultarContenedor = function (elemento) {
	$("body").css("overflow", "hidden");
	$("#cont-pantalla-ppal").show();
	$(elemento + " cont-btns-flot-bottom").hide();
	$(elemento).addClass("slideOutDown animated").one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
		function () {
			$(elemento).hide();
			$(elemento).removeClass("slideOutDown animated");
			$("body").css("overflow", "auto");
		});
}

/**
 * Obtiene un array a partir de los datos de una cadena de texto
 */
window.getArrayFromCadena = function (cadena) {
	if (cadena == null || cadena.length == 0)
		return new Array();

	cadena = cadena.replace(/^#*/, "").replace(/#*$/, "");
	let array = cadena.split("#");
	for (let i in array)
		array[i] = parseInt(array[i]);
	return array;
}

/**
 * Genera una cadena de texto a partir de los datos de un array
 * @param arrayCanales
 * @returns {String}
 */
window.getCadenaFromArray = function (array) {
	if (array.length == 0)
		return "";

	array.sort(function (a, b) { return a - b; });

	let cadena = "#";
	for (let i in array)
		cadena += array[i] + "#";
	return cadena;
}

/* ================ DATOS EN LOCAL STORAGE ================ */

window.guardarEmpresaUsuarioLS = function (id) {
	localStorage.setItem('empresa_backoffice', id);
}

window.obtenerEmpresaUsuarioLS = function () {
	return localStorage.getItem('empresa_backoffice');
}


window.guardarRecintoUsuarioLS = function (id) {
	localStorage.setItem('recinto_backoffice', id);
}

window.obtenerRecintoUsuarioLS = function () {
	return localStorage.getItem('recinto_backoffice');
}


window.guardarSalaUsuarioLS = function (id) {
	localStorage.setItem('sala_backoffice', id);
}

window.obtenerSalaUsuarioLS = function () {
	return localStorage.getItem('sala_backoffice');
}

window.obtenerSessionUsuarioLS = function () {
	return localStorage.getItem('session_backoffice');
}

window.guardarSessionUsuarioLS = function (id) {
	localStorage.setItem('session_backoffice', id);
}


window.guardarEventoUsuarioLS = function (id) {
	localStorage.setItem('evento_backoffice', id);
}

window.obtenerEventoUsuarioLS = function () {
	return localStorage.getItem('evento_backoffice');
}

window.guardarSesionUsuarioLS = function (id) {
	localStorage.setItem('sesion_backoffice', id);
}

window.saveChannelUserLS = function (id) {
	localStorage.setItem('channel_backoffice', id);
}

window.getChannelUserLS = function (id) {
	return localStorage.getItem('channel_backoffice');
}

window.obtenerSesionUsuarioLS = function () {
	return localStorage.getItem('sesion_backoffice');
}

window.addTimeDatepicker = function (datePicker, horas, minutos, segundos) {
	let dateMoment = parseDateTime(datePicker);
	if (dateMoment.isValid()) {
		dateMoment = dateMoment.add(horas, 'hours');
		dateMoment = dateMoment.add(minutos, 'minutes');
		dateMoment = dateMoment.add(segundos, 'seconds');
		return dateMoment;
	}
}


// --- LOCAL STORAGE ---
window.setPropLocalStorage = function (propertyKey, valueProp) {
	const keyinput = propertyKey;
	const valoutput = valueProp;
	if (typeof (window.localStorage) != 'undefined') {
		window.localStorage.setItem(keyinput, valoutput);
	} else {
		throw "window.localStorage, not defined";
	}
}

window.getPropLocalStorage = function (propertyKey) {
	let valoutput;
	if (typeof (window.localStorage) != 'undefined') {
		valoutput = window.localStorage.getItem(propertyKey);
	}
	else {
		throw "window.localStorage, not defined";
	}
	return valoutput;
}

// --- SESION STORAGE ---
window.setPropSessionStorage = function (propertyKey, valueProp) {
	const keyinput = propertyKey;
	const valoutput = valueProp;
	if (typeof (window.sessionStorage) != 'undefined') {
		window.sessionStorage.setItem(keyinput, valoutput);
	} else {
		throw "window.sessionStorage, not defined";
	}
}

window.setPropSessionStorage = function (propertyKey) {
	let valoutput;
	if (typeof (window.sessionStorage) != 'undefined') {
		valoutput = window.sessionStorage.getItem(propertyKey);
	}
	else {
		throw "window.sessionStorage, not defined";
	}
	return valoutput;
}

// --- Multilanguage modal ---

window.showMultilanguageModal = function (title, placeholder) {
	if (title == null) {
		title = "";
	}

	$("#multilanguageTitle").text(title);

	if (placeholder) {
		$("#multilanguage-texts .language-wrapper").each(function (i) {
			$("textarea").attr("placeholder", placeholder);
		});
	}

	showModal("#multilanguage-modal");
}

window.hideNonActiveLanguages = function (uniqueIdCompany) {
	let idCompany = $('#filtro_idEmpresa').val();

	if (uniqueIdCompany) {
		idCompany = uniqueIdCompany;
	}
	else if (idCompany == 'undefined') {
		idCompany = idEmpresaUsuario;
	}

	if (idCompany != null) {
		idCompany = parseInt(idCompany);
		let company = null;

		let datosSala;

		for (let i in DatosSalas) {
			datosSala = DatosSalas[i];
			if (datosSala.idEmpresa == idCompany) {
				company = { idEmpresa: datosSala.idEmpresa, activeLanguages: datosSala.activeLanguages };
				break;
			}
		}

		if (company != null) {
			window.hideNonActiveLanguagesForTextareas(company);
			hideNonActiveLanguagesForSelectors(company);
		}
	}
}

window.hideNonActiveLanguagesForSelectors = function (company) {
	$('.language-selector option').show();

	if (company.activeLanguages && company.activeLanguages.length > 0) {
		$('.language-selector option').each(function () {
			const value = $(this).val();
			let found = false;

			for (let i in company.activeLanguages) {
				const activeLang = company.activeLanguages[i];
				if (activeLang.lang == value) {
					found = true;
				}
			}

			found ? $(this).show() : $(this).hide();
		});
	}
}

window.hideNonActiveLanguagesForTextareas = function (company) {
	$(".language-wrapper").show();

	if (company.activeLanguages && company.activeLanguages.length > 0) {
		$(".language-wrapper .contDescripcionIdioma").each(function (i) {

			const elementId = $(this).attr("id");
			let found = false;

			let activeLang;

			for (let j in company.activeLanguages) {
				activeLang = company.activeLanguages[j];
				if (elementId.endsWith(activeLang.lang)) {
					found = true;
					break;
				}
			}

			found ? $(this).parent().parent().show() : $(this).parent().parent().hide();
		});
	}
}

// ---- MULTIIDIOMA ----

/**
 * Establece un objeto de TextoMultiidioma
 * @param idType ID del elemento que va a contener cada texto
 * @param textoMultiidioma TextoMultiidioma
 */
window.setTextoMultiidioma = function (idElement, textoMultiidioma) {
	if (idElement != null) {
		for (let i = 0; i < idiomas.length; i++) {
			$(idElement + idiomas[i]).val("");
		}

		if (textoMultiidioma != null) {
			const idiomasTexts = textoMultiidioma.idiomas;
			const textos = textoMultiidioma.textos;

			for (let i = 0; i < idiomasTexts.length; i++) {
				$(idElement + idiomasTexts[i]).val(textos[i]);
			}
		}
	}
}

/**
 * Devuelve un objeto TextoMultiidioma
 * @param idContainer Id del contenedor de textos multiidioma
 * @param idElement Id del elemento que contiene cada texto
 * @returns
 */
window.getTextoMultiidioma = function (idContainer, idElement) {
	if (idContainer != null) {
		const textoMultiidioma = new TextoMultiidioma();

		$(idContainer + " .contDescripcionIdioma").each(function (indice, elemento) {
			const idObj = $(elemento).attr("id");
			if (idObj != null) {
				const idioma = idObj.replace(idElement, "");
				const texto = $(elemento).val();

				if (texto != null && texto != "") {
					textoMultiidioma.idiomas.push(idioma);
					textoMultiidioma.textos.push(texto);
				}
			}
		});

		return textoMultiidioma;
	}

	return null;
}


/**
 * Return a multilanguage object
 * @param idContainer Id del contenedor de textos multiidioma
 * @param idElement Id del elemento que contiene cada texto
 * @returns
 */
window.getTextsMultilanguage = function (idContainer, idElement) {
	if (idContainer != null) {
		const textMultilanguage = new TextoMultiidioma();

		$(idContainer + " .multilanguage_text").each(function (indice, elemento) {
			const idObj = $(elemento).attr("id");
			if (idObj != null) {
				const language = idObj.replace(idElement, "");
				const text = $(elemento).val();

				if (text != null && text != "") {
					textMultilanguage.idiomas.push(language);
					textMultilanguage.textos.push(text);
				}
			}
		});

		return textMultilanguage;
	}

	return null;
}


/**
 * Returns Text of requested language
 * @param language
 * @return text of requested language
 */
window.getTranslatedText = function (languagesList, textsList, defaultTextValue, language) {

	if (language != null) {
		if (languagesList != null) {
			for (let i = 0; i < languagesList.length; i++) {
				if (language == languagesList[i]) {
					return textsList[i];
				}
			}
		}
	}

	return defaultTextValue;
}

/**
 * Returns Translation of requested language
 * @param multilanguageTextField MultilanguageText field
 * @param defaultTextValue default text
 * @param language
 * @return text of requested language
 */
window.getMultilanguageTranslation = function (multilanguageTextField, defaultTextValue, language) {
	if (multilanguageTextField == null || multilanguageTextField.idiomas == null || multilanguageTextField.textos == null ||
		multilanguageTextField.idiomas.length == 0 || multilanguageTextField.textos.length == 0) {
		return defaultTextValue;
	}

	const defaultText = (multilanguageTextField.textoDefault != null) ? multilanguageTextField.textoDefault : defaultTextValue;

	return window.getTranslatedText(multilanguageTextField.idiomas, multilanguageTextField.textos, defaultText, language);
}

/**
 * Returns a string without html characters
 */
String.prototype.escape = function () {
	const tagsToReplace = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
	};
	return this.replace(/[&<>"]/g, function (tag) {
		return tagsToReplace[tag] || tag;
	});
};

/**
 * Returns a random string containing [A-Za-z0-9] of requested length
 */
window.getRandomString = function (stringLength) {
	let text = "";
	const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	for (let i = 0; i < stringLength; i++) {
		text += possible.charAt(Math.floor(Math.random() * possible.length));
	}
	return text;
}

window.getLiteralEstadoPago = function (idEstadoPago) {
	let litEstadoPago;
	let currentIdEstadoPago;

	for (let i = 0; i < Object.keys(window.EstadosPago).length; i++) {
		litEstadoPago = Object.keys(window.EstadosPago)[i];
		currentIdEstadoPago = window.EstadosPago[litEstadoPago];

		if (idEstadoPago == currentIdEstadoPago) {
			return litEstadoPago;
		}
	}
	return "";
}

//================ REMEMBER USERS AFTER LOGIN ====================

window.updateAccountList = function () {
	//TODO: Limit to activity view
	const accountsList = window.getPropLocalStorage('accountsList');

	if (accountsList == null) {
		window.setPropLocalStorage('accountsList', JSON.stringify([]));
	}
	return window.addCurrentLoginToList();
}

window.addCurrentLoginToList = function () {
	const loginName = $('.name').html().replace(/ |\n/g, '');
	const loginType = $('.type').last().data().idtype;

	if (!window.existsLoginInList(loginName)) {
		const currentList = JSON.parse(window.getPropLocalStorage('accountsList'));
		const urlForType = "/backoffice/empresa/0/profile_icon/" + loginType + ".svg";

		currentList.push({
			login: loginName,
			type: loginType,
			imageURL: urlForType
		});
		return window.setPropLocalStorage('accountsList', JSON.stringify(currentList));
	}
}

window.existsLoginInList = function (loginName) {
	const currentList = JSON.parse(window.getPropLocalStorage('accountsList'));

	let currentAccount;

	for (let i = 0; i < currentList.length; i++) {
		currentAccount = currentList[i];
		if (currentAccount.login == loginName) {
			return true;
		}
	}
	return false;
}

window.customDatatableFiltering = function (elementId, datatableId, position) {
	if (elementId == null || elementId == "" || datatableId == null || datatableId == "") {
		return;
	}

	const filter = $(elementId).val();
	if (filter != null && filter.length > 0 && filter.indexOf("\"") != -1 &&
		(filter.length > 2 && filter.charAt(0) === "\"" && filter.charAt(filtro.length - 1) === "\"")
	) {
		const literalStr = filter.substring(1, filtro.length - 1);
		$(datatableId).dataTable().fnFilter("^" + literalStr + "$", position, true, false);
	}
	else {
		$(datatableId).dataTable().fnFilter(filter, position);
	}
}

window.sleep = function (milliseconds) {
	const start = new Date().getTime();
	for (let i = 0; i < 1e7; i++) {
		if ((new Date().getTime() - start) > milliseconds) {
			break;
		}
	}
}

window.deepCopy = function (obj) {
	if (Object.prototype.toString.call(obj) === '[object Array]') {
		let out = [], i = 0, len = obj.length;
		for (; i < len; i++) {
			//            out[i] = arguments.callee(obj[i]);
		}
		return out;
	}
	return obj;
}

window.screenSize = function () {
	const width = $(window).width();
	if (width <= 640) {
		return window.SIZE_WINDOW.MOBILE;
	}
	else if (width > 640 && width <= 966) {
		return window.SIZE_WINDOW.TABLET;
	}
	else if (width > 966) {
		return window.SIZE_WINDOW.DESKTOP;
	}
}

window.lightOrDark = function (color) {

	// Variables for red, green, blue values
	let r, g, b, hsp;

	// Check the format of the color, HEX or RGB?
	if (color.match(/^rgb/)) {

		// If HEX --> store the red, green, blue values in separate variables
		color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

		r = color[1];
		g = color[2];
		b = color[3];
	}
	else {

		// If RGB --> Convert it to HEX: http://gist.github.com/983661
		color = +("0x" + color.slice(1).replace(
			color.length < 5 && /./g, '$&$&'));

		r = color >> 16;
		g = color >> 8 & 255;
		b = color & 255;
	}

	// HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
	hsp = Math.sqrt(
		0.299 * (r * r) +
		0.587 * (g * g) +
		0.114 * (b * b)
	);

	// Using the HSP value, determine whether the color is light or dark
	return hsp > 127.5 ? 'light' : 'dark';
}

window.returnOnlyNumber = function (string) {
	let out = '';
	const filter = '1234567890';

	for (let i = 0; i < string.length; i++)
		if (filter.indexOf(string.charAt(i)) != -1)
			out += string.charAt(i);

	return out;
}

window.onStreamingPlatformChanged = function () {
	$(".streaming-field").hide();

	const selectedPlatformId = $("#streaming-type").val();
	const selectedPlatform = window.getObjetoPorId(selectedPlatformId, window.StreamingPlatforms, "id");
	const platformFields = selectedPlatform.requiredFields.split("#");

	for (let i in platformFields) {
		$("#wrapper-streaming-" + platformFields[i]).show();
	}
}

window.getStreamingFieldsValues = function (streamingSetup) {
	const platform = window.getObjetoPorId(streamingSetup.type, window.StreamingPlatforms, "id");
	const platformFields = platform.requiredFields.split("#");
	const timeZone = $('#streaming-timezone').val();
	streamingSetup.timezone = timeZone;

	let fieldName;

	for (let i in platformFields) {
		fieldName = platformFields[i];
		if (fieldName == "url")
		{
			if($("#streaming-" + fieldName).val() == null || $("#streaming-" + fieldName).val() == '')
			{
				streamingSetup[fieldName] = null;
			}
			streamingSetup[fieldName] = encodeURIComponent($("#streaming-" + fieldName).val());
		}
		else if (fieldName == "showUrl")
		{
			streamingSetup[fieldName] = $("#streaming-showUrl").prop('checked');
		}
		else if (fieldName == "onlyOneSessionByTicket")
		{
			streamingSetup[fieldName] = $("#streaming-onlyOneSessionByTicket").prop('checked');
		}
		else if (fieldName == "transmissionStart")
		{
			if($("#streaming-transmissionStart").val() == null || $("#streaming-transmissionStart").val() == '')
			{
				streamingSetup[fieldName] = null;
			}
			else
			{
				streamingSetup[fieldName] = dayjs.tz($("#streaming-transmissionStart").val(), 'L LT', timeZone).valueOf();
			}
		}
		else if (fieldName == "transmissionStop")
		{
			if($("#streaming-transmissionStop").val() == null || $("#streaming-transmissionStop").val() == '')
			{
				streamingSetup[fieldName] = null;
			}
			else
			{
				streamingSetup[fieldName] = dayjs.tz($("#streaming-transmissionStop").val(), 'L LT', timeZone).valueOf();
			}
		}
		else
		{
			if($("#streaming-" + fieldName).val() == null || $("#streaming-" + fieldName).val() == '')
			{
				streamingSetup[fieldName] = null;
			}
			else
			{
				streamingSetup[fieldName] = $("#streaming-" + fieldName).val();
			}
		}
	}
}

window.setStreamingFieldValues = function (streamingSetup) {
	const platform = window.getObjetoPorId(streamingSetup.type, window.StreamingPlatforms, "id");
	const platformFields = platform.requiredFields.split("#");
	let hideShowUrl = false;

	let fieldName;

	for (let i in platformFields) {
		fieldName = platformFields[i];

		if (fieldName == "url") {
			$("#streaming-" + fieldName).val(decodeURIComponent(streamingSetup[fieldName]));
		}
		else if (fieldName == "showUrl") {
			if (streamingSetup[fieldName]) {
				$("#streaming-showUrl").prop("checked", true);
			}
			else {
				$("#streaming-showUrl").prop("checked", false);
			}
		}
		else if (fieldName == "onlyOneSessionByTicket") {
			if (streamingSetup[fieldName]) {
				$("#streaming-onlyOneSessionByTicket").prop("checked", true);
				hideShowUrl = true;
			}
			else {
				$("#streaming-onlyOneSessionByTicket").prop("checked", false);
			}
		}
		else if (fieldName == "transmissionStart") {
			if (streamingSetup[fieldName] != null) {
				$("#streaming-transmissionStart").val(formatDateTime(streamingSetup[fieldName])).fdatetimepicker('update');
			}
			else {
				$("#streaming-transmissionStart").val("");
			}
		}
		else if (fieldName == "transmissionStop") {
			if (streamingSetup[fieldName] != null) {
				$("#streaming-transmissionStop").val(formatDateTime(streamingSetup[fieldName])).fdatetimepicker('update');
			}
			else {
				$("#streaming-transmissionStop").val("");
			}
		}
		else {
			$("#streaming-" + fieldName).val(streamingSetup[fieldName]);
		}
	}

	if (hideShowUrl) {
		setTimeout(function () {
			$("#wrapper-streaming-showUrl").hide();
		}, 100);
	}
	else {
		setTimeout(function () {
			$("#wrapper-streaming-showUrl").show();
		}, 100);
	}
}

window.setStreamingOneSession = function () {

	if ($("#streaming-onlyOneSessionByTicket").prop("checked")) {
		$("#streaming-showUrl").prop("checked", false);
		$("#streaming-showUrl").prop("disabled", true);
	}
	else {
		$("#streaming-showUrl").prop("disabled", false);
	}
}

window.validateTimeAndFormat = function (timeValue) {
	const timeEmpty = "00:00:00";
	if (timeValue == "" || timeValue.indexOf(":") < 0) {
		return timeEmpty;
	}
	else {
		let sHours = timeValue.split(':')[0];
		let sMinutes = timeValue.split(':')[1];

		if (sHours == "" || isNaN(sHours) || parseInt(sHours) > 23) {
			return timeEmpty;
		}
		else if (parseInt(sHours) == 0) {
			sHours = "00";
		}
		else if (sHours < 10) {
			sHours = "0" + sHours;
		}

		if (sMinutes == "" || isNaN(sMinutes) || parseInt(sMinutes) > 59) {
			return timeEmpty;
		}
		else if (parseInt(sMinutes) == 0) {
			sMinutes = "00";
		}
		else if (sMinutes < 10) {
			sMinutes = "0" + sMinutes;
		}

		timeValue = sHours + ":" + sMinutes + ":" + "00";
		return timeValue;
	}

}

window.normalizarUrl = function (str) {
	const from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç ¿?¡!&=;,#<>'\"", to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc--------------", mapping = {};

	for (let i = 0, j = from.length; i < j; i++)
		mapping[from.charAt(i)] = to.charAt(i);

	let ret = [];
	let c;

	for (let i = 0, j = str.length; i < j; i++) {
		c = str.charAt(i);
		if (mapping.hasOwnProperty(str.charAt(i)))
			ret.push(mapping[c]);
		else
			ret.push(c);
	}
	return ret.join('').replace(/--+/, "-");
}

window.getCountrynameFromCode = function (code) {
	let name = '';
	let currentRegion;

	for (let i = 0; i < regions.length; i++) {
		currentRegion = regions[i];
		if (currentRegion.iso == code) {
			name = currentRegion.country;
		}
	}
	return name;
}


window.getTextMultilanguage = function (multiLangArray) {
	if (multiLangArray != null) {
		const languagesArray = multiLangArray.idiomas;
		const textsArray = multiLangArray.textos;

		for (let i = 0; i < languagesArray.length; i++) {
			if (languagesArray[i] == currentLanguage) {
				return textsArray[i];
			}
		}
		return multiLangArray.textoDefault;
	}
}

window.getSpecialProductsVenueId = function (idOrganization) {
	let dt;

	for (let i in DatosSalas) {
		dt = DatosSalas[i];
		if (dt.idEmpresa == idOrganization && dt.venueType == window.VENUE_TYPE.SPECIAL_PRODUCTS) {
			return dt.idRecinto;
		}
	}
}

window.getSpecialProductsVenueRoomId = function (idOrganization) {
	let dt;

	for (let i in DatosSalas) {
		dt = DatosSalas[i];
		if (dt.idEmpresa == idOrganization && dt.venueType == window.VENUE_TYPE.SPECIAL_PRODUCTS) {
			return dt.idSala;
		}
	}
}

window.getOthersProductsVenueRoomId = function (idOrganization, idVenue) {
	let dt;

	for (let i in DatosSalas) {
		dt = DatosSalas[i];
		if (dt.idEmpresa == idOrganization && dt.idRecinto != null && dt.idRecinto == idVenue && dt.venueType != window.VENUE_TYPE.SPECIAL_PRODUCTS) {
			if (dt.idSala != null && dt.idSala < 0) {
				return dt.idSala;
			}
		}
	}
}

window.clearEventListeners = function (selector) {
	const old_element = document.querySelector(selector);
	const new_element = old_element.cloneNode(true);
	old_element.parentNode.replaceChild(new_element, old_element);
}


window.validateEmail = function (email) {
	const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

window.isInternetExplorer = function () {
	const ua = window.navigator.userAgent;
	return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0;
}

window.isIE = window.isInternetExplorer();

window.csvToArray = function (text, separator) {
	if (separator == null || separator == "") {
		separator = ",";
	}

  	text = text.replace(/"/g, '').replace(/'/g, "");

	const regexValid = new RegExp("^\\s*(?:'[^'\\\\]*(?:\\\\[\\S\\s][^'\\\\]*)*'|\"[^\"\\\\]*(?:\\\\[\\S\\s][^\"\\\\]*)*\"|[^;'\"\\s\\\\]*(?:\\s+[^;'\"\\s\\\\]+)*)\\s*(?:;\\s*(?:'[^'\\\\]*(?:\\\\[\\S\\s][^'\\\\]*)*'|\"[^\"\\\\]*(?:\\\\[\\S\\s][^\"\\\\]*)*\"|[^;'\"\\s\\\\]*(?:\\s+[^;'\"\\s\\\\]+)*)\\s*)*$".replaceAll(";", separator));
	const regexValue = new RegExp("(?!\\s*$)\\s*(?:\'([^\'\\\\]*(?:\\\\[\\S\\s][^\'\\\\]*)*)\'|\"([^\"\\\\]*(?:\\\\[\\S\\s][^\"\\\\]*)*)\"|([^;\'\"\\s\\\\]*(?:\\s+[^;\'\"\\s\\\\]+)*))\\s*(?:;|$)".replaceAll(";", separator), "g");
	const regexFinalSeparator = new RegExp(";\s*$".replaceAll(";", separator));

	// Return NULL if input string is not well formed CSV string.
	if (!regexValid.test(text)) return null;
	let a = [];                     // Initialize array to receive values.
	text.replace(regexValue, // "Walk" the string using replace with callback.
		function (m0, m1, m2, m3) {
			// Remove backslash from \' in single quoted values.
			if (m1 !== undefined) a.push(m1.replace(/\\'/g, "'"));
			// Remove backslash from \" in double quoted values.
			else if (m2 !== undefined) a.push(m2.replace(/\\"/g, '"'));
			else if (m3 !== undefined) a.push(m3);
			return ''; // Return empty string.
		});

	// Handle special case of empty last value.
	if (regexFinalSeparator.test(text)) a.push('');
	return a;
}

window.normalizeLabel = function (label, maxRange) {
	let normalizedLabel = label;
	if (label != null && label.length > maxRange) {
		normalizedLabel = label.substring(label, maxRange);
	}
	return normalizedLabel;
}

window.checkValidDecimalNumberInput = function (event, value, maxlength) {
	const numberOfDotsAndCommas = value.indexOf('.') + value.indexOf(',');
	const checkOnlyOneDotOrComma = (event.key === '.' && numberOfDotsAndCommas < 0) || (event.key === ',' && numberOfDotsAndCommas < 0);
	return (checkOnlyOneDotOrComma && value.length < maxlength - 1) || (isFinite(event.key)) ? true : false;
}

//ADDRESS EDITOR

window.currentAddressEditor = null;

window.COUNTRIES_WITH_STATES = ['US', 'MX', 'CA'];

window.originalLabelNames = null;

window.configureCountrySelect = function () {
	window.loadTransalatedCountrySelect('#country');
}

window.configureCustomCountrySelect = function (elementId, filteredCountriesList) {
	window.loadTransalatedCountrySelect(elementId, filteredCountriesList);
}

window.getCountryISOCodes = function() {
    return COUNTRIES.map(country => country.iso);
};

window.countrySelected = function (countryCode) {
	if (currentAddressEditor === null) {
		return;
	}

	let statesContainer = '';
	
	if(countryCode == null) countryCode = $('#country').val();

	if (COUNTRIES_WITH_STATES.includes(countryCode)) {
		statesContainer = '#stateSelect';
		window.setPopulationOrStateInput('#state', '#population');
	}
	else {
		statesContainer = '#populationSelect';
		window.setPopulationOrStateInput('#population', '#state');
	}

	$(statesContainer).attr('required', false);

	currentAddressEditor.countryConfiguration = getCountry($('#country').val());

	window.configureAddressFormFields(currentAddressEditor.countryConfiguration);

	currentAddressEditor.loadStates(countryCode != null ? countryCode : currentAddressEditor.country, statesContainer);

	currentAddressEditor.changeAllInputsDisabledProperty(false);
	
	phonePrefix = getObjetoPorId(countryCode != null ? countryCode : currentAddressEditor.country, COUNTRIES, "iso").phone_prefix;
}

window.phonePrefix = null;

window.configureAddressFormFields = function (countryConfiguration)
{
	if (countryConfiguration == null)
	{
		return;
	}


	configureFieldsVisibility(countryConfiguration);

	configureFieldsText(countryConfiguration);
	
	configureOptionalFields(countryConfiguration);
}

window.configureFieldsVisibility = function(countryConfiguration)
{
		if (countryConfiguration.fields.province.hidden) {
		$("#stateInput").parent().hide();
		$("#populationInput").parent().hide();
		$("#stateInput").attr("required", false);
		$("#populationInput").attr("required", false);
		$("#populationInput").val('');
		$("#stateInput").val('');
	}
	else {
		$("#stateInput").parent().show();
		$("#populationInput").parent().show();

		if (currentAddressEditor.addressEditorConfig.address.isMandatory) {
			$("#city").attr("required", true);
		}
	}

	if (countryConfiguration.fields.locality.hidden) {
		$("#city").attr("disabled", true);
		$("#city").attr("required", false);
		$("#city").val('');
	}
	else {
		$("#city").attr("disabled", false);

		if (currentAddressEditor.addressEditorConfig.address.isMandatory) {
			$("#city").attr("required", true);
		}
	}

	if (countryConfiguration.fields.postal_code.hidden) {
		$("#pc").parent().hide();
		$("#pc").attr("required", false);
		$("#pc").val('');
	}
	else {
		$("#pc").parent().show();
		if (currentAddressEditor.addressEditorConfig.address.isMandatory) {
			$("#pc").attr("required", true);
		}
	}

	if (countryConfiguration.fields.address_1.hidden) {
		$("#addressLine1").parent().hide();
		$("#addressLine1").attr("required", false);
		$("#addressLine1").val("");
	}
	else {
		$("#addressLine1").parent().show();

		if (currentAddressEditor.addressEditorConfig.address.isMandatory) {
			$("#addressLine1").attr("required", true);
		}
	}

	if (countryConfiguration.fields.address_2.hidden) {
		$("#addressLine2").parent().hide();
		$("#addressLine2").val("");
	}
	else {
		$("#addressLine2").parent().show();
	}

	if (countryConfiguration.fields.district.hidden) {
		$('#addressDistrict').parent().hide();
		$("#district").val("");
	}
	else {
		$('#addressDistrict').parent().show();
	}
}

window.configureFieldsText = function(countryConfiguration)
{
	if (originalLabelNames == null) 
	{
		originalLabelNames = 
		{
			"postal_code": document.getElementById('pcLabel').innerText,
			"address_1": document.getElementById('addressLine1Label').innerText,
			"address_2": document.getElementById('addressLine2Label').innerText,
			"locality": document.getElementById('cityLabel').innerText,
			"district": document.getElementById('addressDistrict').innerText
		}
	}

	if (countryConfiguration.fields.province.name != null) {
		document.querySelector('#stateInput label').innerText = countryConfiguration.fields.province.name;
		document.querySelector('#populationInput label').innerText = countryConfiguration.fields.province.name;
	}

	if(countryConfiguration.fields.locality.name != null)
	{
		document.getElementById('cityLabel').innerText = polyglot.t(countryConfiguration.fields.locality.name);
		document.getElementById('city').placeholder = polyglot.t(countryConfiguration.fields.locality.name);
	}
	else
	{
		document.getElementById('cityLabel').innerText = originalLabelNames.locality;
		document.getElementById('city').placeholder = originalLabelNames.locality;
	}

	if (countryConfiguration.fields.postal_code.name != null) {
		document.getElementById('pcLabel').innerText = countryConfiguration.fields.postal_code.name;
	}
	else {
		document.getElementById('pcLabel').innerText = originalLabelNames.postal_code;
	}

	if (countryConfiguration.fields.address_1.name != null) {
		document.getElementById('addressLine1Label').innerText = countryConfiguration.fields.address_1.name;
	}
	else {
		document.getElementById('addressLine1Label').innerText = originalLabelNames.address_1;
	}

	if (countryConfiguration.fields.address_2.name != null) {
		document.getElementById('addressLine2Label').innerText = countryConfiguration.fields.address_2.name;
	}
	else {
		document.getElementById('addressLine2Label').innerText = originalLabelNames.address_2;
	}
	
	if(countryConfiguration.fields.district.name != null)
	{
		document.getElementById('addressDistrict').innerText = polyglot.t(countryConfiguration.fields.district.name);
		document.getElementById('district').placeholder = polyglot.t(countryConfiguration.fields.district.name);
	}
	else
	{
		document.getElementById('addressDistrict').innerText = originalLabelNames.district;
		document.getElementById('district').placeholder = originalLabelNames.district;
	}
}

window.configureOptionalFields = function(countryConfiguration)
{
	if(currentAddressEditor == null || currentAddressEditor.countryConfiguration == null || !currentAddressEditor.addressEditorConfig.address.isMandatory)
	{
		return;
	}
	
	if(!currentAddressEditor.countryConfiguration.fields.province.hidden) $("#stateInput").attr("required", !currentAddressEditor.countryConfiguration.fields.province.optional);
	if(!currentAddressEditor.countryConfiguration.fields.province.hidden) $("#populationInput").attr("required", !currentAddressEditor.countryConfiguration.fields.province.optional);
	if(!currentAddressEditor.countryConfiguration.fields.address_1.hidden) $("#addressLine1").attr("required", !currentAddressEditor.countryConfiguration.fields.address_1.optional);
	if(!currentAddressEditor.countryConfiguration.fields.postal_code.hidden) $("#pc").attr("required", !currentAddressEditor.countryConfiguration.fields.postal_code.optional);
	if(!currentAddressEditor.countryConfiguration.fields.locality.hidden) $("#city").attr("required", !currentAddressEditor.countryConfiguration.fields.locality.optional);
}

window.filterCountriesList = function(filteredList)
{
	let countriesList = COUNTRIES;
	if (filteredList)
	{
		countriesList = [];
		for (let country of COUNTRIES)
		{
			if (filteredList.includes(country.iso))
			{
				countriesList.push(country);
			}
		}
	}
	
	return countriesList;
}

window.loadTransalatedCountrySelect = function (selector, filteredCountriesList) {
	const translatedCountrySuggestions = window.generateTranslatedCountriesSuggestion(filteredCountriesList);
	const componentId = (selector == undefined) ? "#countryAccredited" : selector;
	$(componentId).empty();
	$.each(translatedCountrySuggestions, function (i, option) {
		$(componentId).append($("<option>", option));
	});
}

window.generateTranslatedCountriesSuggestion = function (filteredList) {

	let translatedCountriesList = [];

	initializeCountriesLang(currentLanguage);

	const countriesList = filterCountriesList(filteredList);

	let country;
	let translatedCountrySuggestionOption;

	for (let i = 0; i < countriesList.length; i++) {
		country = countriesList[i];
		translatedCountrySuggestionOption = {
			value: country.iso,
			text: country.country,
			phoneprefix: country.phone_prefix
		};
		translatedCountriesList.push(translatedCountrySuggestionOption);
	}

	return translatedCountriesList;
}

window.setPopulationOrStateInput = function (newInput, oldInput) {
	$(oldInput + 'Input').hide();
	$(newInput + 'Input').show();
	$(oldInput + "Select").attr("required", false);
}

window.zipCodeSelected = function () {
	currentAddressEditor.fillDataOnZipcodeSelected(null);
}

window.goBackToAddressEditorModal = function (modal) {
	hideModal(modal);
	setTimeout(function () {
		showModal('#vAddressEditor');
	}, 320);
}

window.selectSuggestedAddress = function (position) {
	currentAddressEditor.selectSuggestedAddress(position);
}

window.saveSuggestedAddress = function () {
	currentAddressEditor.saveSuggestedAddress();
}

window.selectSuggestedCity = function (position)
{
	currentAddressEditor.selectSuggestedCity(position);
}

window.setStateCode = function () {
	stateCodeSelectedNotSaved = document.getElementById('stateInput').style.display == 'none' ? $('#populationSelect').val() : $('#stateSelect').val();
}

window.saveNotValidatedAddress = function () {
	setToNoValidate = true;
	$('#formAddressEdition').submit();
}

window.saveCityByPosition = function () {
	currentAddressEditor.saveCityByPosition();
}

window.expandPanel = function(elemento) 
{
	const panelExpanded = localStorage.getItem("isPanelExpanded") || "false";

	const panels = document.querySelectorAll('div.contentPanel');
	const iconsBtn = document.querySelectorAll('div.expand-panel-btn');

	panels.forEach(function(div) {
		if(panelExpanded == "true")
		{
			div.classList.add('smallSize');
			div.classList.remove('halfSize');
		}
		else
		{
			div.classList.remove('smallSize');
			div.classList.add('halfSize');
		}
	});
	
	iconsBtn.forEach(function(div) {
		if(panelExpanded == "true")
		{
			div.classList.remove('smallSize');
			div.classList.add('halfSize');
			div.classList.remove('rotate180');
		}
		else
		{
			div.classList.add('smallSize');
			div.classList.remove('halfSize');
			div.classList.add('rotate180');
		}
	});

	const isPanelExpanded = panelExpanded == "true";

	localStorage.setItem("isPanelExpanded", !isPanelExpanded);
}

window.addAutotestChoicesIds = function(containerId)
{
	let searchTerm = document.getElementById(containerId);
	let choicesDivId = containerId + 'Div';
	if(searchTerm != null) searchTerm.parentNode.parentNode.id = choicesDivId;
	let choicesSearch = document.querySelector("#" + choicesDivId + " input[type='search']");
	if(choicesSearch != null) choicesSearch.id = containerId + 'Search';
}

window.getListaEmpresas = function(companyTypesFilter)
{
	var idEmpresaAnterior = -1;
	var lista = new Array();

	for (var i in DatosSalas)
	{
		var dt = DatosSalas[i];

		if (dt.idEmpresa == idEmpresaAnterior)
			continue;

		var companyTypes = getArrayFromCadena(dt.companyTypes);
		var companyTypeMatches = false;

		for (var j in companyTypes)
		{
			for (var k in companyTypesFilter)
			{
				if (companyTypes[j] == companyTypesFilter[k])
				{
					companyTypeMatches = true;
					break;
				}
			}
		}

		if (!companyTypeMatches)
			continue;

		idEmpresaAnterior = dt.idEmpresa;

		var iv = new IdValor();
		iv.id = dt.idEmpresa;
		iv.valor = dt.nombreComercial;
		lista.push(iv);
	}
	return lista;
}

window.initiatedSeatMapEditing = async function(hallId)
{
	let infoHallObject = sessionStorage.getItem("infoHallObject");
	if(infoHallObject)
	{
		infoHallObject = JSON.parse(infoHallObject);
	}
	const editedByPersonId = infoHallObject ? infoHallObject.editedByPersonId.toString() : "";
	const hallIdStringified = hallId ? hallId.toString() : "";
	
	const data = {
		editedByPersonId,
		hallId: hallIdStringified
	}
	
	return new Promise((resolve, reject) => {
		ZonasRecintoAjax.flagSeatMapForEditing(JSON.stringify(data), res => {
			resolve(handleSeatEditing(hallId, res));
		});
	});
}

window.handleSeatEditing = function(hallId, result) 
{
	if(typeof result == "undefined" || result == null)
	{
		return;
	}

	result = JSON.parse(result);

	const status = result.status;
	const editedByPersonId = result.user.editedByPersonId;

	const infoHallObj = {
		hallId,
		status,
		editedByPersonId
	};
	
	sessionStorage.setItem("infoHallObject", JSON.stringify(infoHallObj));
	

	if (status == "400")
	{
		const msg = result.message;
		const name = result.user.name;
		const ip = result.user.ip;
		const deadLine = formatTimeSeconds(result.deadline);
		const errorMessage = polyglot.t(msg, { person: name });
		const footer = polyglot.t("rooms.Is_being_edited_extra_information", {userIp: ip, timeLeft: deadLine});
		sessionStorage.setItem("infoHallObject", "");
		cambiarVentanaEsperaKO(false, errorMessage, footer);
	}

	return infoHallObj;
};

window.sleepDelay = function sleep(delay) 
{
  var start = new Date().getTime();
  while (new Date().getTime() < start + delay);
}
 
window.countdownDuration = 30;
window.countdownInterval = null;

window.updateSwalContent = function() {
	swal({
		title: polyglot.t("seatMap.Inactivity_detected"),
		html: `<strong>${polyglot.t("seatMap.Do_you_want_to_keep_editing")}</strong> <br> ${polyglot.t("seatMap.Time_remaining_count_down", {countdownDuration:countdownDuration})}`,
		type: "info",
		showCancelButton: true,
		confirmButtonText: polyglot.t("Continue_editing"),
		cancelButtonText: "No",
		confirmButtonClass: 'btn-alert right',
		cancelButtonClass: 'btn-alert-secondary'
	}).then(function() {
		clearInterval(window.countdownInterval);
		window.countdownInterval = null;
		window.countdownDuration = 30;
	}, function(dismiss) {
		window.countdownDuration = 30;
		window.countdownInterval = null;
		clearInterval(window.countdownInterval);
		$('#filtro' + '_idSala').val(null).change();
		location.href = "zonesVenues";
	});
}

window.startCountdown = function() {
	window.updateSwalContent();
	window.countdownInterval = setInterval(function() {
		window.countdownDuration--;

		window.updateSwalContent();

		// Check if the countdown has reached 0
		if (window.countdownDuration === 0) {
			clearInterval(window.countdownDuration);
			$('#filtro' + '_idSala').val(null).change();
			location.href = "zonesVenues";
		}
	}, 1000);
}



window.findPropertyByValue = function (obj, targetValue) {
	const keys = Object.keys(obj);
	const propertyName = keys.find(key => obj[key] === targetValue);
	return propertyName || null;
  }

window.isValidHtmlCode = function(value)
{
	const tagRegex = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/g;

	return tagRegex.test(value);
}

window.isValidCssCode = function(value)
{
	const blocks = value.split('{');
	const openingBraceCount = blocks.length - 1;
	const closingBraceCount = value.split('}').length - 1;

	return openingBraceCount === closingBraceCount;
}

window.isValidJsCode = function(value)
{
	try
	{
		new Function(value)();
		return true;
	}
	catch (error)
	{
		return false;
	}
}


window.checkCountryCodeFormat = function(countryCode)
{
	let countryCodeFormatted = countryCode;
	if(countryCodeFormatted != null && countryCodeFormatted.length > 2)
	{
		let countryRetrieved = getObjetoPorId(countryCode, COUNTRIES, country);
		
		if(countryRetrieved == null)
		{
			let country = null;
			for(let i = 0; i < COUNTRIES.length; i++)
			{
				country = COUNTRIES[i];
				
				if(country.translations != null && Object.values(country.translations).filter(t => t.indexOf(countryCode) >= 0).length > 0)
				{
					countryCodeFormatted = country.iso;
					break;
				}
			}
		}
		else
		{
			countryCodeFormatted = countryRetrieved.iso;
		}
	}
	
	return countryCodeFormatted;
}

window.checkPhoneNumberFormat = function(phoneNumber, countryCode)
{
	if(typeof phoneNumber == 'undefined' || phoneNumber == null)
	{
		return null;
	}
	
	let phoneNumberFormatted = phoneNumber;
	
	phoneNumberFormatted = phoneNumberFormatted.replace(/[^0-9]/g, "");
	
	if(countryCode != null)
	{
		let countryRetrieved = getObjetoPorId(countryCode, COUNTRIES, "iso");
	
		if(countryRetrieved != null && phoneNumberFormatted.startsWith(countryRetrieved.phone_prefix))
		{
			phoneNumberFormatted = phoneNumberFormatted.replace(countryRetrieved.phone_prefix, "");
		}
	}
	
	return phoneNumberFormatted;
}

window.getCsvField = function(value)
{
	if (value != null && value != "null" && value.length > 0)
	{
		return value.trim();
	}

	return null;
}